export const DEFAULT_TREND_CURSOR_DATA = {
    groups: {},
    trendCursors: {},
    trendCursorValues: {},
};
export const DEFAULT_GROUPING = {
    trendCursors: [],
    connectedCharts: [],
};
